// ui message
export const TOGGLE_MESSAGE = 'ui/TOGGLE_MESSAGE';

// Sider
export const TOGGLE_COLLAPSE = 'ui/TOGGLE_COLLAPSE';
export const TOGGLE_GLOBAL_LOADER = 'ui/TOGGLE_GLOBAL_LOADER';

export const SET_UP = 'ui/SET_UP';
export const SET_UP_ADMIN = 'ui/SET_UP_ADMIN';

export const SET_CURRENT_HOME_VIEW = 'ui/SET_CURRENT_HOME_VIEW';

export const RESET_UI_ENV = 'ui/RESET_UI_ENV';

export const SET_GLOBAL_BASKET = 'ui/SET_GLOBAL_BASKET';
export const SET_QUOTATION_BASKET = 'ui/SET_QUOTATION_BASKET';
export const SET_MOUNT_QUOTATIONS = 'ui/SET_MOUNT_QUOTATIONS';

export const SET_GLOBAL_PAYMENT_DATA = 'ui/SET_GLOBAL_PAYMENT_DATA';
export const SET_GLOBAL_SELECTED_MOUNT = 'ui/SET_GLOBAL_SELECTED_MOUNT';
export const TOGGLE_MODAL_EFFECT_CREATION = 'ui/TOGGLE_MODAL_EFFECT_CREATION';
export const SET_THEME = 'ui/SET_THEME';
